import { render } from "./MovieList.vue?vue&type=template&id=679f8413"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__